/**
 * @fileoverview This file is generated by the Angular 2 template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties}
 */
 /* tslint:disable */

import * as import0 from '../../../../../public/upgrade/feature/ageRange/age-range.component';
import * as import1 from '@angular/core/src/linker/view';
import * as import2 from '@angular/core/src/render/api';
import * as import3 from '@angular/core/src/linker/view_utils';
import * as import4 from '@angular/core/src/metadata/view';
import * as import5 from '../../../../../public/upgrade/feature/ageRange/age-range.service';
import * as import6 from '../../../../../public/upgrade/feature/ageRange/age-range-validator.service';
import * as import7 from '@angular/core/src/linker/view_type';
import * as import8 from '@angular/core/src/change_detection/constants';
import * as import9 from '@angular/core/src/linker/component_factory';
import * as import10 from '@angular/http/src/http';
import * as import11 from '../../../../../public/upgrade/core/session.service';
import * as import12 from '@angular/core/src/zone/ng_zone';
import * as import13 from '../../../../../public/upgrade/root/loading/loading-wheel.service';
import * as import14 from '@angular/router/src/router_state';
import * as import15 from '../../../../../public/upgrade/root/modal/modal.service';
import * as import16 from '../../../../../public/upgrade/root/toast/notification.service';
import * as import17 from '../../../../../public/upgrade/root/ga/ga.service';
import * as import18 from '@angular/forms/src/form_builder';
import * as import19 from '../../../../../public/upgrade/shared/select-container/select-container.component';
import * as import20 from '../../shared/select-container/select-container.component.ngfactory';
import * as import21 from '@ngx-translate/core/src/translate.pipe';
import * as import22 from '@angular/core/src/linker/view_container';
import * as import23 from '@ngx-translate/core/src/translate.service';
import * as import24 from '@angular/core/src/change_detection/change_detection_util';
import * as import25 from '../../../../../public/upgrade/shared/input-container/input-container.component';
import * as import26 from '../../shared/input-container/input-container.component.ngfactory';
import * as import27 from '../../../../node_modules/@angular/common/src/directives/ng_if.ngfactory';
import * as import28 from '@angular/core/src/linker/template_ref';
import * as import29 from '@angular/common/src/directives/ng_if';
import * as import30 from '../../../../node_modules/@angular/forms/src/directives/ng_form.ngfactory';
import * as import31 from '../../../../node_modules/@angular/forms/src/directives/ng_control_status.ngfactory';
import * as import32 from '@angular/forms/src/directives/ng_form';
import * as import33 from '@angular/forms/src/directives/control_container';
import * as import34 from '@angular/forms/src/directives/ng_control_status';
export class Wrapper_AgeRangeComponent {
  /*private*/ _eventHandler:Function;
  context:import0.AgeRangeComponent;
  /*private*/ _changed:boolean;
  constructor(p0:any,p1:any,p2:any,p3:any,p4:any,p5:any,p6:any,p7:any,p8:any,p9:any) {
    this._changed = false;
    this.context = new import0.AgeRangeComponent(p0,p1,p2,p3,p4,p5,p6,p7,p8,p9);
  }
  ngOnDetach(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any):void {
  }
  ngOnDestroy():void {
  }
  ngDoCheck(view:import1.AppView<any>,el:any,throwOnChange:boolean):boolean {
    var changed:any = this._changed;
    this._changed = false;
    if (!throwOnChange) { if ((view.numberOfChecks === 0)) { this.context.ngOnInit(); } }
    return changed;
  }
  checkHost(view:import1.AppView<any>,componentView:import1.AppView<any>,el:any,throwOnChange:boolean):void {
  }
  handleEvent(eventName:string,$event:any):boolean {
    var result:boolean = true;
    return result;
  }
  subscribe(view:import1.AppView<any>,_eventHandler:any):void {
    this._eventHandler = _eventHandler;
  }
}
var renderType_AgeRangeComponent_Host:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,([] as any[]),{});
class View_AgeRangeComponent_Host0 extends import1.AppView<any> {
  _el_0:any;
  compView_0:import1.AppView<import0.AgeRangeComponent>;
  _AgeRangeService_0_3:import5.AgeRangeService;
  _AgeRangeValidatorService_0_4:import6.AgeRangeValidatorService;
  _AgeRangeComponent_0_5:Wrapper_AgeRangeComponent;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_AgeRangeComponent_Host0,renderType_AgeRangeComponent_Host,import7.ViewType.HOST,viewUtils,parentView,parentIndex,parentElement,import8.ChangeDetectorStatus.CheckAlways);
  }
  createInternal(rootSelector:string):import9.ComponentRef<any> {
    this._el_0 = import3.selectOrCreateRenderHostElement(this.renderer,'age-range',import3.EMPTY_INLINE_ARRAY,rootSelector,(null as any));
    this.compView_0 = new View_AgeRangeComponent0(this.viewUtils,this,0,this._el_0);
    this._AgeRangeService_0_3 = new import5.AgeRangeService(this.injectorGet(import10.Http,this.parentIndex));
    this._AgeRangeValidatorService_0_4 = new import6.AgeRangeValidatorService();
    this._AgeRangeComponent_0_5 = new Wrapper_AgeRangeComponent(this.injectorGet(import11.SessionService,this.parentIndex),this._AgeRangeService_0_3,this.injectorGet(import12.NgZone,this.parentIndex),this.injectorGet(import13.LoadingWheelService,this.parentIndex),this._AgeRangeValidatorService_0_4,this.injectorGet(import14.ActivatedRoute,this.parentIndex),this.injectorGet(import15.ModalService,this.parentIndex),this.injectorGet(import16.NotificationService,this.parentIndex),this.injectorGet(import17.GAService,this.parentIndex),this.injectorGet(import18.FormBuilder,this.parentIndex));
    this.compView_0.create(this._AgeRangeComponent_0_5.context);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [this._el_0]),(null as any));
    return new import9.ComponentRef_<any>(0,this,this._el_0,this._AgeRangeComponent_0_5.context);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import5.AgeRangeService) && (0 === requestNodeIndex))) { return this._AgeRangeService_0_3; }
    if (((token === import6.AgeRangeValidatorService) && (0 === requestNodeIndex))) { return this._AgeRangeValidatorService_0_4; }
    if (((token === import0.AgeRangeComponent) && (0 === requestNodeIndex))) { return this._AgeRangeComponent_0_5.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    this._AgeRangeComponent_0_5.ngDoCheck(this,this._el_0,throwOnChange);
    this.compView_0.internalDetectChanges(throwOnChange);
  }
  destroyInternal():void {
    this.compView_0.destroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
export const AgeRangeComponentNgFactory:import9.ComponentFactory<import0.AgeRangeComponent> = new import9.ComponentFactory<import0.AgeRangeComponent>('age-range',View_AgeRangeComponent_Host0,import0.AgeRangeComponent);
const styles_AgeRangeComponent:any[] = ([] as any[]);
class View_AgeRangeComponent1 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  compView_4:import1.AppView<import19.SelectContainerComponent>;
  _SelectContainerComponent_4_3:import20.Wrapper_SelectContainerComponent;
  _text_5:any;
  _text_6:any;
  _text_7:any;
  _pipe_translate_0:import21.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import22.ViewContainer) {
    super(View_AgeRangeComponent1,renderType_AgeRangeComponent,import7.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import8.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import9.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-sm'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-12'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                                ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'select-container',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_4 = new import20.View_SelectContainerComponent0(this.viewUtils,this,4,this._el_4);
    this._SelectContainerComponent_4_3 = new import20.Wrapper_SelectContainerComponent();
    this._text_5 = this.renderer.createText((null as any),'\n                                ',(null as any));
    this.compView_4.create(this._SelectContainerComponent_4_3.context);
    this._text_6 = this.renderer.createText(this._el_2,'\n                            ',(null as any));
    this._text_7 = this.renderer.createText(this._el_0,'\n                        ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_4,new import3.InlineArray4(4,'modelChange',(null as any),'change',(null as any)),this.eventHandler(this.handleEvent_4));
    this._SelectContainerComponent_4_3.subscribe(this,this.eventHandler(this.handleEvent_4),false,true);
    this._pipe_translate_0 = new import21.TranslatePipe(this.parentView.injectorGet(import23.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._text_6,
      this._text_7
    ]
    ),[disposable_0]);
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import19.SelectContainerComponent) && ((4 <= requestNodeIndex) && (requestNodeIndex <= 5)))) { return this._SelectContainerComponent_4_3.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import24.ValueUnwrapper();
    const currVal_4_0_0:any = 'minimumAge';
    this._SelectContainerComponent_4_3.check_id(currVal_4_0_0,throwOnChange,false);
    const currVal_4_0_1:any = 'minimumAge';
    this._SelectContainerComponent_4_3.check_name(currVal_4_0_1,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_4_0_2:any = valUnwrapper.unwrap(this._pipe_translate_0.transform('age_ranges.MIN_AGE'));
    this._SelectContainerComponent_4_3.check_label(currVal_4_0_2,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_4_0_3:any = 'md';
    this._SelectContainerComponent_4_3.check_size(currVal_4_0_3,throwOnChange,false);
    const currVal_4_0_4:boolean = !this.parentView.context.editableAgeRange;
    this._SelectContainerComponent_4_3.check_disabled(currVal_4_0_4,throwOnChange,false);
    const currVal_4_0_5:any = this.parentView.context.listMinAge;
    this._SelectContainerComponent_4_3.check_list(currVal_4_0_5,throwOnChange,false);
    const currVal_4_0_6:any = true;
    this._SelectContainerComponent_4_3.check_disableDefault(currVal_4_0_6,throwOnChange,false);
    const currVal_4_0_7:any = this.parentView.context.ageRange.minimumRentalAge;
    this._SelectContainerComponent_4_3.check_model(currVal_4_0_7,throwOnChange,false);
    this._SelectContainerComponent_4_3.ngDoCheck(this,this._el_4,throwOnChange);
    this.compView_4.internalDetectChanges(throwOnChange);
    if (!throwOnChange) { if ((this.numberOfChecks === 0)) { this._SelectContainerComponent_4_3.context.ngAfterViewInit(); } }
  }
  destroyInternal():void {
    this.compView_4.destroy();
    this._SelectContainerComponent_4_3.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_4(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.context.ageRange.minimumRentalAge = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'change')) {
      const pd_sub_1:any = ((<any>this.parentView.context.updateMaxAgeList($event)) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
}
class View_AgeRangeComponent3 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import22.ViewContainer) {
    super(View_AgeRangeComponent3,renderType_AgeRangeComponent,import7.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import8.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import9.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'span',new import3.InlineArray2(2,'class','money -eva-3-mt-md'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'%',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_AgeRangeComponent4 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import22.ViewContainer) {
    super(View_AgeRangeComponent4,renderType_AgeRangeComponent,import7.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import8.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import24.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import9.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'span',new import3.InlineArray2(2,'class','money -eva-3-mt-md'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),(null as any));
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const currVal_2:any = import3.inlineInterpolate(1,'',this.parentView.parentView.context.metadata.currencyCode,'');
    if (import3.checkBinding(throwOnChange,this._expr_2,currVal_2)) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
}
class View_AgeRangeComponent2 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  compView_4:import1.AppView<import19.SelectContainerComponent>;
  _SelectContainerComponent_4_3:import20.Wrapper_SelectContainerComponent;
  _text_5:any;
  _text_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _el_14:any;
  _text_15:any;
  _el_16:any;
  compView_16:import1.AppView<import19.SelectContainerComponent>;
  _SelectContainerComponent_16_3:import20.Wrapper_SelectContainerComponent;
  _text_17:any;
  _text_18:any;
  _text_19:any;
  _text_20:any;
  _text_21:any;
  _text_22:any;
  _text_23:any;
  _el_24:any;
  _text_25:any;
  _el_26:any;
  _text_27:any;
  _el_28:any;
  compView_28:import1.AppView<import25.InputContainerComponent>;
  _InputContainerComponent_28_3:import26.Wrapper_InputContainerComponent;
  _text_29:any;
  _text_30:any;
  _anchor_31:any;
  /*private*/ _vc_31:import22.ViewContainer;
  _TemplateRef_31_5:any;
  _NgIf_31_6:import27.Wrapper_NgIf;
  _text_32:any;
  _anchor_33:any;
  /*private*/ _vc_33:import22.ViewContainer;
  _TemplateRef_33_5:any;
  _NgIf_33_6:import27.Wrapper_NgIf;
  _text_34:any;
  _text_35:any;
  _text_36:any;
  _pipe_translate_0:import21.TranslatePipe;
  _pipe_translate_1:import21.TranslatePipe;
  _pipe_translate_2:import21.TranslatePipe;
  _pipe_translate_3:import21.TranslatePipe;
  _pipe_translate_4:import21.TranslatePipe;
  _pipe_translate_5:import21.TranslatePipe;
  _pipe_translate_6:import21.TranslatePipe;
  _pipe_translate_7:import21.TranslatePipe;
  _pipe_translate_8:import21.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import22.ViewContainer) {
    super(View_AgeRangeComponent2,renderType_AgeRangeComponent,import7.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import8.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
  }
  createInternal(rootSelector:string):import9.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-sm'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','col -lg-4 -md-4 -sm-12'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n                                ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'select-container',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_4 = new import20.View_SelectContainerComponent0(this.viewUtils,this,4,this._el_4);
    this._SelectContainerComponent_4_3 = new import20.Wrapper_SelectContainerComponent();
    this._text_5 = this.renderer.createText((null as any),'\n                                ',(null as any));
    this.compView_4.create(this._SelectContainerComponent_4_3.context);
    this._text_6 = this.renderer.createText(this._el_2,'\n                            ',(null as any));
    this._text_7 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','col -lg-4 -md-4 -sm-12'),(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n                                ',(null as any));
    this._el_10 = import3.createRenderElement(this.renderer,this._el_8,'div',new import3.InlineArray2(2,'class','content -top-left'),(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'\n                                    ',(null as any));
    this._el_12 = import3.createRenderElement(this.renderer,this._el_10,'div',new import3.InlineArray2(2,'class','eva-3-select -md'),(null as any));
    this._text_13 = this.renderer.createText(this._el_12,'\n                                        ',(null as any));
    this._el_14 = import3.createRenderElement(this.renderer,this._el_12,'div',new import3.InlineArray2(2,'class','select-container'),(null as any));
    this._text_15 = this.renderer.createText(this._el_14,'\n                                            ',(null as any));
    this._el_16 = import3.createRenderElement(this.renderer,this._el_14,'select-container',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_16 = new import20.View_SelectContainerComponent0(this.viewUtils,this,16,this._el_16);
    this._SelectContainerComponent_16_3 = new import20.Wrapper_SelectContainerComponent();
    this._text_17 = this.renderer.createText((null as any),'\n                                            ',(null as any));
    this.compView_16.create(this._SelectContainerComponent_16_3.context);
    this._text_18 = this.renderer.createText(this._el_14,'\n                                            ',(null as any));
    this._text_19 = this.renderer.createText(this._el_14,'\n\n                                        ',(null as any));
    this._text_20 = this.renderer.createText(this._el_12,'\n                                    ',(null as any));
    this._text_21 = this.renderer.createText(this._el_10,'\n                                ',(null as any));
    this._text_22 = this.renderer.createText(this._el_8,'\n                            ',(null as any));
    this._text_23 = this.renderer.createText(this._el_0,'\n                            ',(null as any));
    this._el_24 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','col -lg-4 -md-4 -sm-12'),(null as any));
    this._text_25 = this.renderer.createText(this._el_24,'\n                                ',(null as any));
    this._el_26 = import3.createRenderElement(this.renderer,this._el_24,'div',new import3.InlineArray4(4,'class','content -top-left','style','position: relative;'),(null as any));
    this._text_27 = this.renderer.createText(this._el_26,'\n                                    ',(null as any));
    this._el_28 = import3.createRenderElement(this.renderer,this._el_26,'input-container',import3.EMPTY_INLINE_ARRAY,(null as any));
    this.compView_28 = new import26.View_InputContainerComponent0(this.viewUtils,this,28,this._el_28);
    this._InputContainerComponent_28_3 = new import26.Wrapper_InputContainerComponent();
    this._text_29 = this.renderer.createText((null as any),'\n                                 ',(null as any));
    this.compView_28.create(this._InputContainerComponent_28_3.context);
    this._text_30 = this.renderer.createText(this._el_26,'\n                                    ',(null as any));
    this._anchor_31 = this.renderer.createTemplateAnchor(this._el_26,(null as any));
    this._vc_31 = new import22.ViewContainer(31,26,this,this._anchor_31);
    this._TemplateRef_31_5 = new import28.TemplateRef_(this,31,this._anchor_31);
    this._NgIf_31_6 = new import27.Wrapper_NgIf(this._vc_31.vcRef,this._TemplateRef_31_5);
    this._text_32 = this.renderer.createText(this._el_26,'\n                                    ',(null as any));
    this._anchor_33 = this.renderer.createTemplateAnchor(this._el_26,(null as any));
    this._vc_33 = new import22.ViewContainer(33,26,this,this._anchor_33);
    this._TemplateRef_33_5 = new import28.TemplateRef_(this,33,this._anchor_33);
    this._NgIf_33_6 = new import27.Wrapper_NgIf(this._vc_33.vcRef,this._TemplateRef_33_5);
    this._text_34 = this.renderer.createText(this._el_26,'\n                                ',(null as any));
    this._text_35 = this.renderer.createText(this._el_24,'\n                            ',(null as any));
    this._text_36 = this.renderer.createText(this._el_0,'\n                        ',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_4,new import3.InlineArray4(4,'modelChange',(null as any),'change',(null as any)),this.eventHandler(this.handleEvent_4));
    this._SelectContainerComponent_4_3.subscribe(this,this.eventHandler(this.handleEvent_4),false,true);
    this._pipe_translate_0 = new import21.TranslatePipe(this.parentView.injectorGet(import23.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_1 = new import21.TranslatePipe(this.parentView.injectorGet(import23.TranslateService,this.parentIndex),this.parentView.ref);
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_16,new import3.InlineArray4(4,'modelChange',(null as any),'change',(null as any)),this.eventHandler(this.handleEvent_16));
    this._SelectContainerComponent_16_3.subscribe(this,this.eventHandler(this.handleEvent_16),false,true);
    this._pipe_translate_2 = new import21.TranslatePipe(this.parentView.injectorGet(import23.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_3 = new import21.TranslatePipe(this.parentView.injectorGet(import23.TranslateService,this.parentIndex),this.parentView.ref);
    var disposable_2:Function = import3.subscribeToRenderElement(this,this._el_28,new import3.InlineArray4(4,'modelChange',(null as any),'change',(null as any)),this.eventHandler(this.handleEvent_28));
    this._InputContainerComponent_28_3.subscribe(this,this.eventHandler(this.handleEvent_28),false,false,true);
    this._pipe_translate_4 = new import21.TranslatePipe(this.parentView.injectorGet(import23.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_5 = new import21.TranslatePipe(this.parentView.injectorGet(import23.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_6 = new import21.TranslatePipe(this.parentView.injectorGet(import23.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_7 = new import21.TranslatePipe(this.parentView.injectorGet(import23.TranslateService,this.parentIndex),this.parentView.ref);
    this._pipe_translate_8 = new import21.TranslatePipe(this.parentView.injectorGet(import23.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._text_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._el_14,
      this._text_15,
      this._el_16,
      this._text_17,
      this._text_18,
      this._text_19,
      this._text_20,
      this._text_21,
      this._text_22,
      this._text_23,
      this._el_24,
      this._text_25,
      this._el_26,
      this._text_27,
      this._el_28,
      this._text_29,
      this._text_30,
      this._anchor_31,
      this._text_32,
      this._anchor_33,
      this._text_34,
      this._text_35,
      this._text_36
    ]
    ),[
      disposable_0,
      disposable_1,
      disposable_2
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import19.SelectContainerComponent) && ((4 <= requestNodeIndex) && (requestNodeIndex <= 5)))) { return this._SelectContainerComponent_4_3.context; }
    if (((token === import19.SelectContainerComponent) && ((16 <= requestNodeIndex) && (requestNodeIndex <= 17)))) { return this._SelectContainerComponent_16_3.context; }
    if (((token === import25.InputContainerComponent) && ((28 <= requestNodeIndex) && (requestNodeIndex <= 29)))) { return this._InputContainerComponent_28_3.context; }
    if (((token === import28.TemplateRef) && (31 === requestNodeIndex))) { return this._TemplateRef_31_5; }
    if (((token === import29.NgIf) && (31 === requestNodeIndex))) { return this._NgIf_31_6.context; }
    if (((token === import28.TemplateRef) && (33 === requestNodeIndex))) { return this._TemplateRef_33_5; }
    if (((token === import29.NgIf) && (33 === requestNodeIndex))) { return this._NgIf_33_6.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import24.ValueUnwrapper();
    const currVal_4_0_0:any = 'maxAge';
    this._SelectContainerComponent_4_3.check_id(currVal_4_0_0,throwOnChange,false);
    const currVal_4_0_1:any = 'maxAge';
    this._SelectContainerComponent_4_3.check_name(currVal_4_0_1,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_4_0_2:any = valUnwrapper.unwrap(this._pipe_translate_0.transform('age_ranges.MAX_AGE'));
    this._SelectContainerComponent_4_3.check_label(currVal_4_0_2,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_4_0_3:any = 'md';
    this._SelectContainerComponent_4_3.check_size(currVal_4_0_3,throwOnChange,false);
    const currVal_4_0_4:boolean = !!this.parentView.context.errors['ageTo'];
    this._SelectContainerComponent_4_3.check_invalid(currVal_4_0_4,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_4_0_5:any = valUnwrapper.unwrap(this._pipe_translate_1.transform(this.parentView.context.errorMessages['ageTo']));
    this._SelectContainerComponent_4_3.check_invalidText(currVal_4_0_5,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_4_0_6:boolean = (!this.parentView.context.editableAgeRange || !this.parentView.context.hasCharge);
    this._SelectContainerComponent_4_3.check_disabled(currVal_4_0_6,throwOnChange,false);
    const currVal_4_0_7:any = this.parentView.context.listMaxAge;
    this._SelectContainerComponent_4_3.check_list(currVal_4_0_7,throwOnChange,false);
    const currVal_4_0_8:any = this.parentView.context.ageRange.to;
    this._SelectContainerComponent_4_3.check_model(currVal_4_0_8,throwOnChange,false);
    this._SelectContainerComponent_4_3.ngDoCheck(this,this._el_4,throwOnChange);
    const currVal_16_0_0:any = 'selectForTypeRecharge';
    this._SelectContainerComponent_16_3.check_id(currVal_16_0_0,throwOnChange,false);
    const currVal_16_0_1:any = 'selectForTypeRecharge';
    this._SelectContainerComponent_16_3.check_name(currVal_16_0_1,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_16_0_2:any = valUnwrapper.unwrap(this._pipe_translate_2.transform('age_ranges.CHARGE_TYPE'));
    this._SelectContainerComponent_16_3.check_label(currVal_16_0_2,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_16_0_3:any = 'md';
    this._SelectContainerComponent_16_3.check_size(currVal_16_0_3,throwOnChange,false);
    const currVal_16_0_4:boolean = !!this.parentView.context.errors['chargeType'];
    this._SelectContainerComponent_16_3.check_invalid(currVal_16_0_4,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_16_0_5:any = valUnwrapper.unwrap(this._pipe_translate_3.transform(this.parentView.context.errorMessages['chargeType']));
    this._SelectContainerComponent_16_3.check_invalidText(currVal_16_0_5,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_16_0_6:boolean = (!this.parentView.context.editableAgeRange || !this.parentView.context.hasCharge);
    this._SelectContainerComponent_16_3.check_disabled(currVal_16_0_6,throwOnChange,false);
    const currVal_16_0_7:any = this.parentView.context.chargeTypesList;
    this._SelectContainerComponent_16_3.check_list(currVal_16_0_7,throwOnChange,false);
    const currVal_16_0_8:any = this.parentView.context.ageRange.chargeType;
    this._SelectContainerComponent_16_3.check_model(currVal_16_0_8,throwOnChange,false);
    this._SelectContainerComponent_16_3.ngDoCheck(this,this._el_16,throwOnChange);
    valUnwrapper.reset();
    const currVal_28_0_0:any = ((this.parentView.context.ageRange.chargeType == 'PERCENTAGE')? valUnwrapper.unwrap(this._pipe_translate_4.transform('age_ranges.type.ENTER_PERCENTAGE')): valUnwrapper.unwrap(this._pipe_translate_5.transform('age_ranges.type.ENTER_AMOUNT')));
    this._InputContainerComponent_28_3.check_placeholder(currVal_28_0_0,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_28_0_1:any = 'amountAgeRange';
    this._InputContainerComponent_28_3.check_name(currVal_28_0_1,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_28_0_2:any = ((this.parentView.context.ageRange.chargeType == 'PERCENTAGE')? valUnwrapper.unwrap(this._pipe_translate_6.transform('age_ranges.type.PERCENTAGE')): valUnwrapper.unwrap(this._pipe_translate_7.transform('age_ranges.PRICE_PER_DAY')));
    this._InputContainerComponent_28_3.check_label(currVal_28_0_2,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_28_0_3:boolean = !!this.parentView.context.errors['amountAgeRange'];
    this._InputContainerComponent_28_3.check_invalid(currVal_28_0_3,throwOnChange,false);
    valUnwrapper.reset();
    const currVal_28_0_4:any = valUnwrapper.unwrap(this._pipe_translate_8.transform(this.parentView.context.errorMessages['amountAgeRange']));
    this._InputContainerComponent_28_3.check_invalidText(currVal_28_0_4,throwOnChange,valUnwrapper.hasWrappedValue);
    const currVal_28_0_5:boolean = (!this.parentView.context.editableAgeRange || !this.parentView.context.hasCharge);
    this._InputContainerComponent_28_3.check_disabled(currVal_28_0_5,throwOnChange,false);
    const currVal_28_0_6:any = this.parentView.context.ageRange.value;
    this._InputContainerComponent_28_3.check_model(currVal_28_0_6,throwOnChange,false);
    this._InputContainerComponent_28_3.ngDoCheck(this,this._el_28,throwOnChange);
    const currVal_31_0_0:any = (this.parentView.context.ageRange.chargeType == 'PERCENTAGE');
    this._NgIf_31_6.check_ngIf(currVal_31_0_0,throwOnChange,false);
    this._NgIf_31_6.ngDoCheck(this,this._anchor_31,throwOnChange);
    const currVal_33_0_0:any = (this.parentView.context.ageRange.chargeType == 'AMOUNT');
    this._NgIf_33_6.check_ngIf(currVal_33_0_0,throwOnChange,false);
    this._NgIf_33_6.ngDoCheck(this,this._anchor_33,throwOnChange);
    this._vc_31.detectChangesInNestedViews(throwOnChange);
    this._vc_33.detectChangesInNestedViews(throwOnChange);
    this.compView_4.internalDetectChanges(throwOnChange);
    this.compView_16.internalDetectChanges(throwOnChange);
    this.compView_28.internalDetectChanges(throwOnChange);
    if (!throwOnChange) {
      if ((this.numberOfChecks === 0)) { this._SelectContainerComponent_4_3.context.ngAfterViewInit(); }
      if ((this.numberOfChecks === 0)) { this._SelectContainerComponent_16_3.context.ngAfterViewInit(); }
      if ((this.numberOfChecks === 0)) { this._InputContainerComponent_28_3.context.ngAfterViewInit(); }
    }
  }
  destroyInternal():void {
    this._vc_31.destroyNestedViews();
    this._vc_33.destroyNestedViews();
    this.compView_4.destroy();
    this.compView_16.destroy();
    this.compView_28.destroy();
    this._SelectContainerComponent_4_3.ngOnDestroy();
    this._SelectContainerComponent_16_3.ngOnDestroy();
    this._InputContainerComponent_28_3.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
    this._pipe_translate_3.ngOnDestroy();
    this._pipe_translate_4.ngOnDestroy();
    this._pipe_translate_5.ngOnDestroy();
    this._pipe_translate_6.ngOnDestroy();
    this._pipe_translate_7.ngOnDestroy();
    this._pipe_translate_8.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 31)) { return new View_AgeRangeComponent3(this.viewUtils,this,31,this._anchor_31,this._vc_31); }
    if ((nodeIndex == 33)) { return new View_AgeRangeComponent4(this.viewUtils,this,33,this._anchor_33,this._vc_33); }
    return (null as any);
  }
  handleEvent_4(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.context.ageRange.to = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'change')) {
      const pd_sub_1:any = ((<any>this.parentView.context.validateAgeTo($event)) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
  handleEvent_16(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.context.ageRange.chargeType = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'change')) {
      const pd_sub_1:any = ((<any>this.parentView.context.validateChargeType($event)) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
  handleEvent_28(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'modelChange')) {
      const pd_sub_0:any = ((<any>(this.parentView.context.ageRange.value = $event)) !== false);
      result = (pd_sub_0 && result);
    }
    if ((eventName == 'change')) {
      const pd_sub_1:any = ((<any>this.parentView.context.updateValidation('amountAgeRange')) !== false);
      result = (pd_sub_1 && result);
    }
    return result;
  }
}
class View_AgeRangeComponent5 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  _pipe_translate_0:import21.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import22.ViewContainer) {
    super(View_AgeRangeComponent5,renderType_AgeRangeComponent,import7.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import8.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import24.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import9.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'dsp-button',new import3.InlineArray8(6,'class','-eva-3-mr-sm','qadata','save','size','md'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_0,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_0));
    this._pipe_translate_0 = new import21.TranslatePipe(this.parentView.injectorGet(import23.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),[disposable_0]);
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import24.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_2:any = import3.inlineInterpolate(1,'\n                                ',valUnwrapper.unwrap(this._pipe_translate_0.transform('common.SAVE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_2,currVal_2))) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_0(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.parentView.context.save()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
class View_AgeRangeComponent6 extends import1.AppView<any> {
  _el_0:any;
  _text_1:any;
  /*private*/ _expr_2:any;
  _pipe_translate_0:import21.TranslatePipe;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any,declaredViewContainer:import22.ViewContainer) {
    super(View_AgeRangeComponent6,renderType_AgeRangeComponent,import7.ViewType.EMBEDDED,viewUtils,parentView,parentIndex,parentElement,import8.ChangeDetectorStatus.CheckAlways,declaredViewContainer);
    this._expr_2 = import24.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import9.ComponentRef<any> {
    this._el_0 = import3.createRenderElement(this.renderer,(null as any),'dsp-button',new import3.InlineArray8(6,'qadata','cancel','size','md','variation','link'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_0,new import3.InlineArray2(2,'click',(null as any)),this.eventHandler(this.handleEvent_0));
    this._pipe_translate_0 = new import21.TranslatePipe(this.parentView.injectorGet(import23.TranslateService,this.parentIndex),this.parentView.ref);
    this.init(this._el_0,((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1
    ]
    ),[disposable_0]);
    return (null as any);
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import24.ValueUnwrapper();
    valUnwrapper.reset();
    const currVal_2:any = import3.inlineInterpolate(1,'\n                                ',valUnwrapper.unwrap(this._pipe_translate_0.transform('common.CANCEL')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_2,currVal_2))) {
      this.renderer.setText(this._text_1,currVal_2);
      this._expr_2 = currVal_2;
    }
  }
  destroyInternal():void {
    this._pipe_translate_0.ngOnDestroy();
  }
  visitRootNodesInternal(cb:any,ctx:any):void {
    cb(this._el_0,ctx);
  }
  handleEvent_0(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'click')) {
      const pd_sub_0:any = ((<any>this.parentView.context.cancel()) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}
var renderType_AgeRangeComponent:import2.RenderComponentType = import3.createRenderComponentType('',0,import4.ViewEncapsulation.None,styles_AgeRangeComponent,{});
export class View_AgeRangeComponent0 extends import1.AppView<import0.AgeRangeComponent> {
  _el_0:any;
  _text_1:any;
  _el_2:any;
  _text_3:any;
  _el_4:any;
  _NgForm_4_3:import30.Wrapper_NgForm;
  _ControlContainer_4_4:any;
  _NgControlStatusGroup_4_5:import31.Wrapper_NgControlStatusGroup;
  _text_5:any;
  _el_6:any;
  _text_7:any;
  _el_8:any;
  _text_9:any;
  _el_10:any;
  _text_11:any;
  _el_12:any;
  _text_13:any;
  _text_14:any;
  _text_15:any;
  _text_16:any;
  _el_17:any;
  _text_18:any;
  _el_19:any;
  _text_20:any;
  _el_21:any;
  _text_22:any;
  _el_23:any;
  _text_24:any;
  _el_25:any;
  _text_26:any;
  _text_27:any;
  _el_28:any;
  _text_29:any;
  _text_30:any;
  _text_31:any;
  _text_32:any;
  _anchor_33:any;
  /*private*/ _vc_33:import22.ViewContainer;
  _TemplateRef_33_5:any;
  _NgIf_33_6:import27.Wrapper_NgIf;
  _text_34:any;
  _el_35:any;
  _text_36:any;
  _el_37:any;
  _text_38:any;
  _el_39:any;
  _text_40:any;
  _text_41:any;
  _el_42:any;
  _text_43:any;
  _text_44:any;
  _text_45:any;
  _text_46:any;
  _el_47:any;
  _text_48:any;
  _el_49:any;
  _text_50:any;
  _el_51:any;
  _text_52:any;
  _text_53:any;
  _text_54:any;
  _text_55:any;
  _el_56:any;
  _text_57:any;
  _el_58:any;
  _text_59:any;
  _el_60:any;
  _text_61:any;
  _text_62:any;
  _text_63:any;
  _text_64:any;
  _anchor_65:any;
  /*private*/ _vc_65:import22.ViewContainer;
  _TemplateRef_65_5:any;
  _NgIf_65_6:import27.Wrapper_NgIf;
  _text_66:any;
  _text_67:any;
  _text_68:any;
  _el_69:any;
  _text_70:any;
  _el_71:any;
  _text_72:any;
  _el_73:any;
  _text_74:any;
  _anchor_75:any;
  /*private*/ _vc_75:import22.ViewContainer;
  _TemplateRef_75_5:any;
  _NgIf_75_6:import27.Wrapper_NgIf;
  _text_76:any;
  _anchor_77:any;
  /*private*/ _vc_77:import22.ViewContainer;
  _TemplateRef_77_5:any;
  _NgIf_77_6:import27.Wrapper_NgIf;
  _text_78:any;
  _text_79:any;
  _text_80:any;
  _text_81:any;
  _text_82:any;
  _text_83:any;
  _text_84:any;
  _text_85:any;
  /*private*/ _expr_101:any;
  _pipe_translate_0:import21.TranslatePipe;
  /*private*/ _expr_103:any;
  _pipe_translate_1:import21.TranslatePipe;
  /*private*/ _expr_105:any;
  _pipe_translate_2:import21.TranslatePipe;
  /*private*/ _expr_107:any;
  _pipe_translate_3:import21.TranslatePipe;
  /*private*/ _expr_109:any;
  _pipe_translate_4:import21.TranslatePipe;
  /*private*/ _expr_111:any;
  _pipe_translate_5:import21.TranslatePipe;
  /*private*/ _expr_113:any;
  /*private*/ _expr_114:any;
  constructor(viewUtils:import3.ViewUtils,parentView:import1.AppView<any>,parentIndex:number,parentElement:any) {
    super(View_AgeRangeComponent0,renderType_AgeRangeComponent,import7.ViewType.COMPONENT,viewUtils,parentView,parentIndex,parentElement,import8.ChangeDetectorStatus.CheckAlways);
    this._expr_101 = import24.UNINITIALIZED;
    this._expr_103 = import24.UNINITIALIZED;
    this._expr_105 = import24.UNINITIALIZED;
    this._expr_107 = import24.UNINITIALIZED;
    this._expr_109 = import24.UNINITIALIZED;
    this._expr_111 = import24.UNINITIALIZED;
    this._expr_113 = import24.UNINITIALIZED;
    this._expr_114 = import24.UNINITIALIZED;
  }
  createInternal(rootSelector:string):import9.ComponentRef<any> {
    const parentRenderNode:any = this.renderer.createViewRoot(this.parentElement);
    this._el_0 = import3.createRenderElement(this.renderer,parentRenderNode,'div',new import3.InlineArray2(2,'class','eva-slide -up -start'),(null as any));
    this._text_1 = this.renderer.createText(this._el_0,'\n    ',(null as any));
    this._el_2 = import3.createRenderElement(this.renderer,this._el_0,'div',new import3.InlineArray2(2,'class','container-fluid whitesmoke-section'),(null as any));
    this._text_3 = this.renderer.createText(this._el_2,'\n        ',(null as any));
    this._el_4 = import3.createRenderElement(this.renderer,this._el_2,'form',new import3.InlineArray2(2,'name','ageChargeForm'),(null as any));
    this._NgForm_4_3 = new import30.Wrapper_NgForm((null as any),(null as any));
    this._ControlContainer_4_4 = this._NgForm_4_3.context;
    this._NgControlStatusGroup_4_5 = new import31.Wrapper_NgControlStatusGroup(this._ControlContainer_4_4);
    this._text_5 = this.renderer.createText(this._el_4,'\n            ',(null as any));
    this._el_6 = import3.createRenderElement(this.renderer,this._el_4,'div',new import3.InlineArray2(2,'class','eva-3-container eva3-restyle'),(null as any));
    this._text_7 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_8 = import3.createRenderElement(this.renderer,this._el_6,'div',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_9 = this.renderer.createText(this._el_8,'\n                    ',(null as any));
    this._el_10 = import3.createRenderElement(this.renderer,this._el_8,'div',new import3.InlineArray2(2,'class','-eva-3-mt-md'),(null as any));
    this._text_11 = this.renderer.createText(this._el_10,'\n                        ',(null as any));
    this._el_12 = import3.createRenderElement(this.renderer,this._el_10,'h2',new import3.InlineArray2(2,'class','eva-3-h2 -eva-3-pb-md'),(null as any));
    this._text_13 = this.renderer.createText(this._el_12,'',(null as any));
    this._text_14 = this.renderer.createText(this._el_10,'\n                    ',(null as any));
    this._text_15 = this.renderer.createText(this._el_8,'\n                ',(null as any));
    this._text_16 = this.renderer.createText(this._el_6,'\n\n                ',(null as any));
    this._el_17 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','-eva-3-mt-md'),(null as any));
    this._text_18 = this.renderer.createText(this._el_17,'\n                    ',(null as any));
    this._el_19 = import3.createRenderElement(this.renderer,this._el_17,'div',new import3.InlineArray2(2,'class','eva-3-panel-info -eva-3-bc-white'),(null as any));
    this._text_20 = this.renderer.createText(this._el_19,'\n                        ',(null as any));
    this._el_21 = import3.createRenderElement(this.renderer,this._el_19,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_22 = this.renderer.createText(this._el_21,'\n                            ',(null as any));
    this._el_23 = import3.createRenderElement(this.renderer,this._el_21,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_24 = this.renderer.createText(this._el_23,'\n                                ',(null as any));
    this._el_25 = import3.createRenderElement(this.renderer,this._el_23,'h5',new import3.InlineArray2(2,'class','eva-3-h5'),(null as any));
    this._text_26 = this.renderer.createText(this._el_25,'',(null as any));
    this._text_27 = this.renderer.createText(this._el_23,'\n                                ',(null as any));
    this._el_28 = import3.createRenderElement(this.renderer,this._el_23,'p',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_29 = this.renderer.createText(this._el_28,'',(null as any));
    this._text_30 = this.renderer.createText(this._el_23,'\n                            ',(null as any));
    this._text_31 = this.renderer.createText(this._el_21,'\n                        ',(null as any));
    this._text_32 = this.renderer.createText(this._el_19,'\n                        ',(null as any));
    this._anchor_33 = this.renderer.createTemplateAnchor(this._el_19,(null as any));
    this._vc_33 = new import22.ViewContainer(33,19,this,this._anchor_33);
    this._TemplateRef_33_5 = new import28.TemplateRef_(this,33,this._anchor_33);
    this._NgIf_33_6 = new import27.Wrapper_NgIf(this._vc_33.vcRef,this._TemplateRef_33_5);
    this._text_34 = this.renderer.createText(this._el_19,'\n\n                        ',(null as any));
    this._el_35 = import3.createRenderElement(this.renderer,this._el_19,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-md'),(null as any));
    this._text_36 = this.renderer.createText(this._el_35,'\n                            ',(null as any));
    this._el_37 = import3.createRenderElement(this.renderer,this._el_35,'div',new import3.InlineArray2(2,'class','col -lg-12 -md-12 -sm-12'),(null as any));
    this._text_38 = this.renderer.createText(this._el_37,'\n                                ',(null as any));
    this._el_39 = import3.createRenderElement(this.renderer,this._el_37,'h5',new import3.InlineArray2(2,'class','eva-3-h5'),(null as any));
    this._text_40 = this.renderer.createText(this._el_39,'',(null as any));
    this._text_41 = this.renderer.createText(this._el_37,'\n                                ',(null as any));
    this._el_42 = import3.createRenderElement(this.renderer,this._el_37,'p',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_43 = this.renderer.createText(this._el_42,'',(null as any));
    this._text_44 = this.renderer.createText(this._el_37,'\n                            ',(null as any));
    this._text_45 = this.renderer.createText(this._el_35,'\n                        ',(null as any));
    this._text_46 = this.renderer.createText(this._el_19,'\n\n                        ',(null as any));
    this._el_47 = import3.createRenderElement(this.renderer,this._el_19,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-sm'),(null as any));
    this._text_48 = this.renderer.createText(this._el_47,'\n                            ',(null as any));
    this._el_49 = import3.createRenderElement(this.renderer,this._el_47,'div',new import3.InlineArray2(2,'class','col -lg-6 -md-6 -sm-12'),(null as any));
    this._text_50 = this.renderer.createText(this._el_49,'\n                                ',(null as any));
    this._el_51 = import3.createRenderElement(this.renderer,this._el_49,'label',new import3.InlineArray2(2,'class','eva-label-form eva-3-label-form -md -eva-3-pb-sm'),(null as any));
    this._text_52 = this.renderer.createText(this._el_51,'',(null as any));
    this._text_53 = this.renderer.createText(this._el_49,'\n                            ',(null as any));
    this._text_54 = this.renderer.createText(this._el_47,'\n                        ',(null as any));
    this._text_55 = this.renderer.createText(this._el_19,'\n                        ',(null as any));
    this._el_56 = import3.createRenderElement(this.renderer,this._el_19,'div',new import3.InlineArray2(2,'class','eva-3-row -eva-3-pt-sm'),(null as any));
    this._text_57 = this.renderer.createText(this._el_56,'\n                            ',(null as any));
    this._el_58 = import3.createRenderElement(this.renderer,this._el_56,'div',new import3.InlineArray4(4,'class','col -lg-6 -md-6 -sm-12','qadata','checkNoCharge'),(null as any));
    this._text_59 = this.renderer.createText(this._el_58,'\n                                ',(null as any));
    this._el_60 = import3.createRenderElement(this.renderer,this._el_58,'dsp-switch',import3.EMPTY_INLINE_ARRAY,(null as any));
    this._text_61 = this.renderer.createText(this._el_60,'\n                                ',(null as any));
    this._text_62 = this.renderer.createText(this._el_58,'\n                            ',(null as any));
    this._text_63 = this.renderer.createText(this._el_56,'\n                        ',(null as any));
    this._text_64 = this.renderer.createText(this._el_19,'\n\n                        ',(null as any));
    this._anchor_65 = this.renderer.createTemplateAnchor(this._el_19,(null as any));
    this._vc_65 = new import22.ViewContainer(65,19,this,this._anchor_65);
    this._TemplateRef_65_5 = new import28.TemplateRef_(this,65,this._anchor_65);
    this._NgIf_65_6 = new import27.Wrapper_NgIf(this._vc_65.vcRef,this._TemplateRef_65_5);
    this._text_66 = this.renderer.createText(this._el_19,'\n                    ',(null as any));
    this._text_67 = this.renderer.createText(this._el_17,'\n                ',(null as any));
    this._text_68 = this.renderer.createText(this._el_6,'\n                ',(null as any));
    this._el_69 = import3.createRenderElement(this.renderer,this._el_6,'div',new import3.InlineArray2(2,'class','-eva-3-mt-md'),(null as any));
    this._text_70 = this.renderer.createText(this._el_69,'\n                    ',(null as any));
    this._el_71 = import3.createRenderElement(this.renderer,this._el_69,'div',new import3.InlineArray2(2,'class','eva-3-row'),(null as any));
    this._text_72 = this.renderer.createText(this._el_71,'\n                        ',(null as any));
    this._el_73 = import3.createRenderElement(this.renderer,this._el_71,'div',new import3.InlineArray2(2,'class','col -md-12 -md-6'),(null as any));
    this._text_74 = this.renderer.createText(this._el_73,'\n                            ',(null as any));
    this._anchor_75 = this.renderer.createTemplateAnchor(this._el_73,(null as any));
    this._vc_75 = new import22.ViewContainer(75,73,this,this._anchor_75);
    this._TemplateRef_75_5 = new import28.TemplateRef_(this,75,this._anchor_75);
    this._NgIf_75_6 = new import27.Wrapper_NgIf(this._vc_75.vcRef,this._TemplateRef_75_5);
    this._text_76 = this.renderer.createText(this._el_73,'\n                            ',(null as any));
    this._anchor_77 = this.renderer.createTemplateAnchor(this._el_73,(null as any));
    this._vc_77 = new import22.ViewContainer(77,73,this,this._anchor_77);
    this._TemplateRef_77_5 = new import28.TemplateRef_(this,77,this._anchor_77);
    this._NgIf_77_6 = new import27.Wrapper_NgIf(this._vc_77.vcRef,this._TemplateRef_77_5);
    this._text_78 = this.renderer.createText(this._el_73,'\n                        ',(null as any));
    this._text_79 = this.renderer.createText(this._el_71,'\n                    ',(null as any));
    this._text_80 = this.renderer.createText(this._el_69,'\n                ',(null as any));
    this._text_81 = this.renderer.createText(this._el_6,'\n            ',(null as any));
    this._text_82 = this.renderer.createText(this._el_4,'\n        ',(null as any));
    this._text_83 = this.renderer.createText(this._el_2,'\n    ',(null as any));
    this._text_84 = this.renderer.createText(this._el_0,'\n',(null as any));
    this._text_85 = this.renderer.createText(parentRenderNode,'\n',(null as any));
    var disposable_0:Function = import3.subscribeToRenderElement(this,this._el_4,new import3.InlineArray4(4,'submit',(null as any),'reset',(null as any)),this.eventHandler(this.handleEvent_4));
    this._pipe_translate_0 = new import21.TranslatePipe(this.parentView.injectorGet(import23.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_1 = new import21.TranslatePipe(this.parentView.injectorGet(import23.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_2 = new import21.TranslatePipe(this.parentView.injectorGet(import23.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_3 = new import21.TranslatePipe(this.parentView.injectorGet(import23.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_4 = new import21.TranslatePipe(this.parentView.injectorGet(import23.TranslateService,this.parentIndex),this.ref);
    this._pipe_translate_5 = new import21.TranslatePipe(this.parentView.injectorGet(import23.TranslateService,this.parentIndex),this.ref);
    var disposable_1:Function = import3.subscribeToRenderElement(this,this._el_60,new import3.InlineArray2(2,'change',(null as any)),this.eventHandler(this.handleEvent_60));
    this.init((null as any),((<any>this.renderer).directRenderer? (null as any): [
      this._el_0,
      this._text_1,
      this._el_2,
      this._text_3,
      this._el_4,
      this._text_5,
      this._el_6,
      this._text_7,
      this._el_8,
      this._text_9,
      this._el_10,
      this._text_11,
      this._el_12,
      this._text_13,
      this._text_14,
      this._text_15,
      this._text_16,
      this._el_17,
      this._text_18,
      this._el_19,
      this._text_20,
      this._el_21,
      this._text_22,
      this._el_23,
      this._text_24,
      this._el_25,
      this._text_26,
      this._text_27,
      this._el_28,
      this._text_29,
      this._text_30,
      this._text_31,
      this._text_32,
      this._anchor_33,
      this._text_34,
      this._el_35,
      this._text_36,
      this._el_37,
      this._text_38,
      this._el_39,
      this._text_40,
      this._text_41,
      this._el_42,
      this._text_43,
      this._text_44,
      this._text_45,
      this._text_46,
      this._el_47,
      this._text_48,
      this._el_49,
      this._text_50,
      this._el_51,
      this._text_52,
      this._text_53,
      this._text_54,
      this._text_55,
      this._el_56,
      this._text_57,
      this._el_58,
      this._text_59,
      this._el_60,
      this._text_61,
      this._text_62,
      this._text_63,
      this._text_64,
      this._anchor_65,
      this._text_66,
      this._text_67,
      this._text_68,
      this._el_69,
      this._text_70,
      this._el_71,
      this._text_72,
      this._el_73,
      this._text_74,
      this._anchor_75,
      this._text_76,
      this._anchor_77,
      this._text_78,
      this._text_79,
      this._text_80,
      this._text_81,
      this._text_82,
      this._text_83,
      this._text_84,
      this._text_85
    ]
    ),[
      disposable_0,
      disposable_1
    ]
    );
    return (null as any);
  }
  injectorGetInternal(token:any,requestNodeIndex:number,notFoundResult:any):any {
    if (((token === import28.TemplateRef) && (33 === requestNodeIndex))) { return this._TemplateRef_33_5; }
    if (((token === import29.NgIf) && (33 === requestNodeIndex))) { return this._NgIf_33_6.context; }
    if (((token === import28.TemplateRef) && (65 === requestNodeIndex))) { return this._TemplateRef_65_5; }
    if (((token === import29.NgIf) && (65 === requestNodeIndex))) { return this._NgIf_65_6.context; }
    if (((token === import28.TemplateRef) && (75 === requestNodeIndex))) { return this._TemplateRef_75_5; }
    if (((token === import29.NgIf) && (75 === requestNodeIndex))) { return this._NgIf_75_6.context; }
    if (((token === import28.TemplateRef) && (77 === requestNodeIndex))) { return this._TemplateRef_77_5; }
    if (((token === import29.NgIf) && (77 === requestNodeIndex))) { return this._NgIf_77_6.context; }
    if (((token === import32.NgForm) && ((4 <= requestNodeIndex) && (requestNodeIndex <= 82)))) { return this._NgForm_4_3.context; }
    if (((token === import33.ControlContainer) && ((4 <= requestNodeIndex) && (requestNodeIndex <= 82)))) { return this._ControlContainer_4_4; }
    if (((token === import34.NgControlStatusGroup) && ((4 <= requestNodeIndex) && (requestNodeIndex <= 82)))) { return this._NgControlStatusGroup_4_5.context; }
    return notFoundResult;
  }
  detectChangesInternal(throwOnChange:boolean):void {
    const valUnwrapper:any = new import24.ValueUnwrapper();
    this._NgForm_4_3.ngDoCheck(this,this._el_4,throwOnChange);
    this._NgControlStatusGroup_4_5.ngDoCheck(this,this._el_4,throwOnChange);
    const currVal_33_0_0:any = this.context.endLoading;
    this._NgIf_33_6.check_ngIf(currVal_33_0_0,throwOnChange,false);
    this._NgIf_33_6.ngDoCheck(this,this._anchor_33,throwOnChange);
    const currVal_65_0_0:any = this.context.endLoading;
    this._NgIf_65_6.check_ngIf(currVal_65_0_0,throwOnChange,false);
    this._NgIf_65_6.ngDoCheck(this,this._anchor_65,throwOnChange);
    const currVal_75_0_0:any = this.context.editableAgeRange;
    this._NgIf_75_6.check_ngIf(currVal_75_0_0,throwOnChange,false);
    this._NgIf_75_6.ngDoCheck(this,this._anchor_75,throwOnChange);
    const currVal_77_0_0:any = this.context.editableAgeRange;
    this._NgIf_77_6.check_ngIf(currVal_77_0_0,throwOnChange,false);
    this._NgIf_77_6.ngDoCheck(this,this._anchor_77,throwOnChange);
    this._vc_33.detectChangesInNestedViews(throwOnChange);
    this._vc_65.detectChangesInNestedViews(throwOnChange);
    this._vc_75.detectChangesInNestedViews(throwOnChange);
    this._vc_77.detectChangesInNestedViews(throwOnChange);
    this._NgControlStatusGroup_4_5.checkHost(this,this,this._el_4,throwOnChange);
    valUnwrapper.reset();
    const currVal_101:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_0.transform('age_ranges.TITLE')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_101,currVal_101))) {
      this.renderer.setText(this._text_13,currVal_101);
      this._expr_101 = currVal_101;
    }
    valUnwrapper.reset();
    const currVal_103:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_1.transform('common.GENERAL')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_103,currVal_103))) {
      this.renderer.setText(this._text_26,currVal_103);
      this._expr_103 = currVal_103;
    }
    valUnwrapper.reset();
    const currVal_105:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_2.transform('age_ranges.GENERAL_DESCRIPTION')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_105,currVal_105))) {
      this.renderer.setText(this._text_29,currVal_105);
      this._expr_105 = currVal_105;
    }
    valUnwrapper.reset();
    const currVal_107:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_3.transform('age_ranges.AGE_CHARGES')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_107,currVal_107))) {
      this.renderer.setText(this._text_40,currVal_107);
      this._expr_107 = currVal_107;
    }
    valUnwrapper.reset();
    const currVal_109:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_4.transform('age_ranges.AGE_CHARGES_DESCRIPTION')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_109,currVal_109))) {
      this.renderer.setText(this._text_43,currVal_109);
      this._expr_109 = currVal_109;
    }
    valUnwrapper.reset();
    const currVal_111:any = import3.inlineInterpolate(1,'',valUnwrapper.unwrap(this._pipe_translate_5.transform('age_ranges.ENABLED')),'');
    if ((valUnwrapper.hasWrappedValue || import3.checkBinding(throwOnChange,this._expr_111,currVal_111))) {
      this.renderer.setText(this._text_52,currVal_111);
      this._expr_111 = currVal_111;
    }
    const currVal_113:any = this.context.hasCharge;
    if (import3.checkBinding(throwOnChange,this._expr_113,currVal_113)) {
      this.renderer.setElementProperty(this._el_60,'checked',currVal_113);
      this._expr_113 = currVal_113;
    }
    const currVal_114:boolean = !this.context.editableAgeRange;
    if (import3.checkBinding(throwOnChange,this._expr_114,currVal_114)) {
      this.renderer.setElementProperty(this._el_60,'disabled',currVal_114);
      this._expr_114 = currVal_114;
    }
  }
  destroyInternal():void {
    this._vc_33.destroyNestedViews();
    this._vc_65.destroyNestedViews();
    this._vc_75.destroyNestedViews();
    this._vc_77.destroyNestedViews();
    this._NgForm_4_3.ngOnDestroy();
    this._pipe_translate_0.ngOnDestroy();
    this._pipe_translate_1.ngOnDestroy();
    this._pipe_translate_2.ngOnDestroy();
    this._pipe_translate_3.ngOnDestroy();
    this._pipe_translate_4.ngOnDestroy();
    this._pipe_translate_5.ngOnDestroy();
  }
  createEmbeddedViewInternal(nodeIndex:number):import1.AppView<any> {
    if ((nodeIndex == 33)) { return new View_AgeRangeComponent1(this.viewUtils,this,33,this._anchor_33,this._vc_33); }
    if ((nodeIndex == 65)) { return new View_AgeRangeComponent2(this.viewUtils,this,65,this._anchor_65,this._vc_65); }
    if ((nodeIndex == 75)) { return new View_AgeRangeComponent5(this.viewUtils,this,75,this._anchor_75,this._vc_75); }
    if ((nodeIndex == 77)) { return new View_AgeRangeComponent6(this.viewUtils,this,77,this._anchor_77,this._vc_77); }
    return (null as any);
  }
  handleEvent_4(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    result = (this._NgForm_4_3.handleEvent(eventName,$event) && result);
    return result;
  }
  handleEvent_60(eventName:string,$event:any):boolean {
    this.markPathToRootAsCheckOnce();
    var result:boolean = true;
    if ((eventName == 'change')) {
      const pd_sub_0:any = ((<any>this.context.activateCharge($event)) !== false);
      result = (pd_sub_0 && result);
    }
    return result;
  }
}


// WEBPACK FOOTER //
// ./aot/public/upgrade/feature/ageRange/age-range.component.ngfactory.ts